import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const H2 = styled.h2`
  font-family: 'Pizza Hut';
  font-size: ${rem(20)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray800};
`;
